import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import ProfileSelector from '../../components/ProfileSelector'
import localize from '../../store/localize'
import strings from '../../components/ProfileSelector/profile-selector.json'
import { actionUsersSetUserProfile, actionProfileHideSelector } from '../../actions'

function mapStateToProps(state) {
    const { users, servers, profile } = state
    let user
    if (servers.active !== undefined) {
        if (users.list[servers.active] != null) {
            user = users.list[servers.active][profile.user]
        }
    }
    return {
        server: servers.active,
        profiles: servers.list[servers.active].profiles,
        boundingRectangle: profile.boundingRectangle,
        title: profile.title,
        user,
        localize: value => localize(strings, selectors.getLanguage(state), value),
        open: profile.open,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setProfile: (server, userKey, profile) => {
            dispatch(actionUsersSetUserProfile(server, userKey, profile))
        },
        dismiss: () => {
            dispatch(actionProfileHideSelector())
        },
    }
}

function mergeProps(stateProps, dispatchProps) {
    return {
        userProfile: stateProps.user.profile,
        profiles: stateProps.profiles,
        localize: stateProps.localize,
        boundingRectangle: stateProps.boundingRectangle,
        title: stateProps.title,
        setProfile: (profile) => {
            dispatchProps.setProfile(stateProps.server, stateProps.user.username, profile)
        },
        dismiss: dispatchProps.dismiss,
        open: stateProps.open,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProfileSelector)



// WEBPACK FOOTER //
// ./src/containers/ProfileSelector/profile-selector.js